/**
 * Focus outline style
 */
import { css } from "@oui/system"

const focusOutline = css`
  &:focus {
    box-shadow: 0 0 0 2px rgb(115, 165, 224, 0.5);
    outline: none;
    z-index: 1;
  }
`

export default focusOutline
